// eslint-disable-next-line import/prefer-default-export
export const VERSION = '0.1.0';
